import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.6",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "23",
      height: "16",
      x: "3.5",
      y: "5",
      rx: "2"
    }, null, -1 /* CACHED */),
    _createElementVNode("path", { d: "M11 26h8m-4-5v5M7.5 13.5H11l2-4 3 8 2-4h4.5" }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }